

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, PropSync, VModel} from "vue-property-decorator";

@Component({})
export default class BoListFilters extends Vue {

  // @PropSync('search')
  // protected searchVar!: string;
  @VModel()
  protected searchVar!: string;

  @PropSync('onlyActive')
  protected onlyActiveVar!: boolean;

  @PropSync('onlyAssigned')
  protected onlyAssignedVar!: boolean;

  @Prop()
  protected activeCnt!: number;

  @Prop()
  protected assignedCnt!: number;

  @Prop()
  protected noClear!: boolean;

  protected get appendIcon(): string {
    return (this.searchVar && this.searchVar.length)
        ? 'mdi-backspace'
        : 'mdi-magnify';
  }

  protected get showOnlyActive(): boolean {
    return this.onlyActiveVar !== undefined;
  }

  protected get showOnlyAssigned(): boolean {
    return this.onlyAssignedVar !== undefined;
  }

  protected mounted() {
    if (this.noClear === undefined || !!this.noClear) {
      this.searchVar = '';
      this.onlyAssignedVar = true;
      this.onlyActiveVar = false;
    }
  }

  protected onAppendClicked() {
    this.searchVar = '';
  }

}

